import { FormattedMessage } from 'react-intl';
import { ReactNode } from 'react';
import { ReceiptAlertType, getReceiptAlertTypeFilterTranslationId } from '@synergy/models';

import { PoolSelect, SelectOption } from '../../select';
import { useFilter } from '../context';

export const ReceiptAlertTypeFilter = () => {
    const { filter, updateFilter, registerFilterMap } = useFilter();

    const onSelected = (receiptAlertType?: ReceiptAlertType) => {
        filter.delete('receiptAlertTypes');
        if (receiptAlertType) {
            filter.set('receiptAlertTypes', receiptAlertType);
        }
        updateFilter(filter);
    };

    const getDisplayValue = (receiptAlertTypeValue: unknown): ReactNode => {
        if (typeof receiptAlertTypeValue !== 'string') {
            return '';
        }
        if (receiptAlertTypeValue === Object.values(ReceiptAlertType).join(',')) {
            return <FormattedMessage id="app.filter.allReceiptAlertTypes" />;
        }

        const receiptAlertType = receiptAlertTypeValue as ReceiptAlertType;
        return <FormattedMessage id={getReceiptAlertTypeFilterTranslationId(receiptAlertType)} />;
    };

    registerFilterMap('receiptAlertTypes', getDisplayValue);

    const selectableReceiptAlertTypes: SelectOption[] = Object.values(ReceiptAlertType).map(receiptAlertType => {
        return {
            value: receiptAlertType,
            displayValue: <FormattedMessage id={getReceiptAlertTypeFilterTranslationId(receiptAlertType)} />,
        };
    });

    selectableReceiptAlertTypes.unshift({
        value: Object.values(ReceiptAlertType).join(','),
        displayValue: <FormattedMessage id="app.filter.select.allReceiptAlertTypes" />,
    });

    return (
        <PoolSelect
            displayEmpty={true}
            name="receiptAlertType"
            label={<FormattedMessage id="app.filter.receiptAlertTypes.label" />}
            fullWidth={true}
            value={filter.get('receiptAlertTypes')}
            onValueChange={onSelected}
            noSorting={true}
            options={selectableReceiptAlertTypes}
        />
    );
};
